import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import IntegrationCard from '~/integrations/AvailableAppsPage/IntegrationCard/IntegrationCard';
import { getPMDetails } from '~/integrations/PracticeManagement/pm.utils';
import { integrationModel } from '~/models';
import { PracticeManagement } from '~/types/api.model';
import DoubleLogo from '../../logos/double.svg';
import ConnectKeeperModal from '../ConnectKeeperModal/ConnectKeeperModal';
export const GetKeeperCardTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            KeeperCardTID: {
                Connect: 'keeper-card-connect'
            }
        }
    });
export default function KeeperCard(param) {
    let { integration } = param;
    const { t: keeperTexts } = useLocaleKeys('integrations.apps');
    const overlayContext = useOverlayContext();
    const { KeeperCardTID } = useMemo(()=>GetKeeperCardTID(), []);
    const navigate = useNavigate();
    const keeperDetails = getPMDetails(PracticeManagement.Keeper);
    const openIntegrateWithKeeperModal = ()=>{
        overlayContext.showModal({
            biName: 'connect_keeper_modal',
            closeOnEscapeKey: true,
            closeOnClickOutside: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConnectKeeperModal, {
                    dismissModal: dismissModal
                });
            }
        });
    };
    const handleClick = ()=>{
        if (integrationModel.isLinked(integration)) {
            navigate(routes.keeperSetup);
        } else {
            openIntegrateWithKeeperModal();
        }
    };
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "keeper-card",
        icon: /*#__PURE__*/ _jsx(DoubleLogo, {
            width: 40,
            height: 40
        }),
        title: keeperDetails.name,
        subTitle: keeperTexts.keeper.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_keeper'
            },
            onClick: handleClick,
            testId: KeeperCardTID.Connect(),
            children: integrationModel.isLinked(integration) ? keeperTexts.shared.manageConnection() : keeperTexts.shared.connectButton()
        })
    });
}
